// @flow
import client, { saveJWTToken } from '../../client'

// API Endpoints
export const USER_CONFIRM_EMAIL_ENDPOINT = '/auth/users/confirm_email/'

/**
 * Validate the email confirmation code received in the email
 * @param {Object} data Confirmation data
 * @param {string} data.key User verification key
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const confirmEmail = (data: { key: string }): Promise<any> =>
  client
    .post(USER_CONFIRM_EMAIL_ENDPOINT, {
      body: data,
    })
    .then((res) => {
      if (res.token) {
        saveJWTToken({ token: res.token })
      }
      return res.success
    })

export default confirmEmail
